<template>
  <div class="devices-settings mp-page">
    <PhoneMonitorPanel />

    <section class="mp-panel sms-panel">
      <div class="mp-panel-header">
        <span class="mp-panel-title">短信转发设备</span>
      </div>
      <div class="mp-panel-body">
        <SmsGateway embedded only="devices" />
      </div>
    </section>
  </div>
</template>

<script>
import PhoneMonitorPanel from '../components/PhoneMonitorPanel.vue'
import SmsGateway from './SmsGateway.vue'

export default {
  name: 'DevicesSettings',
  components: { PhoneMonitorPanel, SmsGateway },
}
</script>

<style scoped>
.sms-panel {
  margin-top: 4px;
}
</style>
